/* ============================================================
   sl-map.js  —  map-by studiolab
   Full Maps URL conversion, filters, lazy iframe, keyboard navigation.
   Scoped per [data-sl-map-section] so multiple sections coexist.
   ============================================================ */
(function () {
  'use strict';

  // Short share links need an HTTP redirect that the browser cannot read
  // cross-origin. Full establishment URLs already contain the place CID.
  function embedFromMapsUrl(value) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (!/^(www\.|maps\.)?google\.(com|com\.br)$/.test(url.hostname)) return '';
      if (!/^\/maps(?:\/|$)/.test(url.pathname) && url.hostname.indexOf('maps.') !== 0) return '';
      var cid = url.searchParams.get('cid');
      if (!cid) {
        var data = decodeURIComponent(url.pathname + url.search);
        var matches = data.match(/(?:!1s|ftid=)(0x[0-9a-f]+:0x[0-9a-f]+)/gi) || [];
        if (matches.length !== 1 || /\/maps\/dir\//.test(url.pathname)) return '';
        cid = BigInt(matches[0].split(':')[1]).toString();
      }
      if (!/^\d{1,20}$/.test(cid) || BigInt(cid) <= 0n || BigInt(cid) > 18446744073709551615n) return '';
      return 'https://maps.google.com/maps?cid=' + cid + '&output=embed';
    } catch (e) { return ''; }
  }

  function mapSource(btn) {
    var maps = btn.getAttribute('data-sl-google-maps') || '';
    // Do not substitute an address search when an explicit place URL fails.
    return maps ? embedFromMapsUrl(maps) : (btn.getAttribute('data-sl-embed') || '');
  }

  function clearMap(panel, message) {
    var iframe = panel.querySelector('iframe');
    if (iframe) iframe.remove();
    var placeholder = panel.querySelector('[data-sl-placeholder]');
    if (placeholder) {
      placeholder.style.display = '';
      var text = placeholder.querySelector('p');
      if (text) text.textContent = message;
    }
  }

  function ensureIframe(panel, name, src) {
    var iframe = panel.querySelector('iframe');
    var placeholder = panel.querySelector('[data-sl-placeholder]');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('allow', 'fullscreen');
      iframe.setAttribute('frameborder', '0');
      panel.appendChild(iframe);
      if (placeholder) placeholder.style.display = 'none';
    }
    if (name) iframe.setAttribute('title', 'Mapa: ' + name);
    if (src && iframe.getAttribute('src') !== src) {
      iframe.setAttribute('src', src);
    }
  }

  function getSection(el) {
    return el.closest ? el.closest('[data-sl-map-section]') : null;
  }

  function getTabs(section) {
    var tablist = section.querySelector('[data-sl-map-tablist]');
    if (!tablist) return [];
    return Array.prototype.slice.call(tablist.querySelectorAll('[data-sl-tab]')).filter(function (tab) {
      return !tab.closest('[data-sl-location]').hidden;
    });
  }

  function activate(btn) {
    var section = getSection(btn);
    if (!section) return;
    var panel = section.querySelector('[data-sl-map-panel]');
    if (!panel) return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-sl-tab]'));
    tabs.forEach(function (t) {
      var isActive = t === btn;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    var src = mapSource(btn);
    var name = btn.getAttribute('data-sl-name') || '';

    panel.setAttribute('aria-labelledby', btn.id || '');
    section.__slMapSelectedId = btn.id;
    if (src) ensureIframe(panel, name, src);
    else clearMap(panel, window.Shopify && Shopify.designMode
      ? 'Abra este estabelecimento no Maps e copie o link completo da barra do navegador no campo Link do Google Maps.'
      : 'Veja a localização pelo botão Ver no Google Maps deste estabelecimento.');

    try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); }
    var rail = section.querySelector('[data-sl-map-tablist]');
    if (rail && rail.scrollHeight > rail.clientHeight && getComputedStyle(rail).overflowY === 'auto') {
      var card = btn.closest('[data-sl-location]').getBoundingClientRect();
      var bounds = rail.getBoundingClientRect();
      if (card.top < bounds.top) rail.scrollTop += card.top - bounds.top;
      else if (card.bottom > bounds.bottom) rail.scrollTop += Math.min(card.bottom - bounds.bottom, card.top - bounds.top);
    }
  }

  function mountInitial(section) {
    var panel = section.querySelector('[data-sl-map-panel]');
    if (!panel) return;
    var tabs = getTabs(section);
    var active = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];

    var src;
    var name;
    if (active) {
      src = mapSource(active);
      name = active.getAttribute('data-sl-name') || '';
      section.querySelectorAll('[data-sl-tab]').forEach(function (tab) {
        tab.setAttribute('aria-selected', tab === active ? 'true' : 'false');
        tab.setAttribute('tabindex', tab === active ? '0' : '-1');
      });
      panel.setAttribute('aria-labelledby', active.id || '');
    }
    if (!src && !active) {
      src = section.getAttribute('data-sl-fallback-embed') || '';
      name = '';
    }
    if (src) ensureIframe(panel, name, src);
    else if (active) clearMap(panel, 'Veja a localização pelo botão Ver no Google Maps deste estabelecimento.');
  }

  function bindFilters(section) {
    var controls = section.querySelector('[data-sl-filters]');
    var search = controls && controls.querySelector('[data-sl-search]');
    var state = controls && controls.querySelector('[data-sl-state-filter]');
    var city = controls && controls.querySelector('[data-sl-city-filter]');
    var status = controls && controls.querySelector('[data-sl-result-count]');
    var rail = section.querySelector('[data-sl-map-tablist]');
    var template = section.querySelector('[data-sl-location-template]');
    var pagination = section.querySelector('[data-sl-pages]');
    if (!rail || !template || !pagination) return;
    var empty = section.querySelector('[data-sl-empty]');
    var previous = pagination.querySelector('[data-sl-prev]');
    var next = pagination.querySelector('[data-sl-next]');
    var pageStatus = pagination.querySelector('[data-sl-page-status]');
    var hint = section.querySelector('[data-sl-scroll-hint]');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var page = 0;
    var matches = [];
    var destroyed = false;
    var loading = false;
    var controller;
    var observer;
    var observed = [];
    var initialCards = Array.prototype.slice.call(rail.querySelectorAll('[data-sl-location]'));

    function normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR').trim(); }
    function read(card, selector) { var el = card.querySelector(selector); return el ? el.textContent.trim() : ''; }
    function prepare(record) {
      record.search = normalize([record.name, record.address, record.city, record.state, record.phone, record.instructions].join(' '));
      return record;
    }
    var records = initialCards.map(function (card) {
      var tab = card.querySelector('[data-sl-tab]');
      var link = card.querySelector('[data-sl-directions]');
      return prepare({
        id: tab.id, name: tab.getAttribute('data-sl-name') || '',
        address: read(card, '.sl-location__address'), phone: read(card, '.sl-location__phone'),
        instructions: read(card, '.sl-location__instructions'),
        city: card.getAttribute('data-sl-city') || '', state: card.getAttribute('data-sl-state') || '',
        maps: tab.getAttribute('data-sl-google-maps') || '', embed: tab.getAttribute('data-sl-embed') || '',
        directions: link ? link.getAttribute('href') : '', label: link ? link.textContent.trim() : '',
        editor: card.getAttribute('data-shopify-editor-block')
      });
    });
    var defaultLabel = template.content.querySelector('[data-sl-directions]').textContent;

    function makeCard(record) {
      var card = template.content.querySelector('[data-sl-location]').cloneNode(true);
      card.setAttribute('data-sl-city', record.city);
      card.setAttribute('data-sl-state', record.state);
      if (record.editor) card.setAttribute('data-shopify-editor-block', record.editor);
      var tab = card.querySelector('[data-sl-tab]');
      tab.id = record.id;
      tab.setAttribute('data-sl-block-id', record.id.replace(/^sl-tab-/, ''));
      tab.setAttribute('data-sl-name', record.name);
      tab.setAttribute('data-sl-google-maps', record.maps);
      tab.setAttribute('data-sl-embed', record.embed);
      tab.setAttribute('aria-selected', record.id === section.__slMapSelectedId ? 'true' : 'false');
      tab.tabIndex = record.id === section.__slMapSelectedId ? 0 : -1;
      function text(selector, value) { var el = card.querySelector(selector); el.textContent = value || ''; el.hidden = !value; }
      text('.sl-location__name', record.name || 'Localização');
      text('.sl-location__address', record.address);
      text('.sl-location__instructions', record.instructions);
      text('.sl-location__phone', record.phone);
      card.querySelector('.sl-location__phone').setAttribute('href', 'tel:' + record.phone.replace(/\s/g, ''));
      var link = card.querySelector('[data-sl-directions]');
      var url = record.maps || record.directions;
      link.hidden = !url;
      link.setAttribute('href', url || '');
      link.textContent = record.label || defaultLabel;
      card.querySelector('.sl-location__actions').hidden = !record.phone && !url;
      return card;
    }

    function fill(select, values, label) {
      var current = select.value;
      select.replaceChildren(new Option(label, ''));
      Array.from(new Set(values.filter(Boolean))).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); })
        .forEach(function (value) { select.add(new Option(value, value)); });
      if (Array.prototype.some.call(select.options, function (o) { return o.value === current; })) select.value = current;
    }
    function cities() {
      if (!controls) return;
      fill(city, records.filter(function (r) { return !state.value || r.state === state.value; })
        .map(function (r) { return r.city; }), 'Todas');
    }
    function updateHeight() {
      if (destroyed) return;
      var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sl-location]'));
      if (desktop.matches && cards.length > 4) {
        var gap = parseFloat(getComputedStyle(rail).rowGap) || 0;
        var height = cards.slice(0, 4).reduce(function (sum, card) { return sum + card.getBoundingClientRect().height; }, gap * 3);
        if (height > 0) rail.style.setProperty('--sl-list-max-height', Math.ceil(height) + 'px');
      } else rail.style.removeProperty('--sl-list-max-height');
      hint.hidden = !desktop.matches || rail.scrollHeight <= rail.clientHeight + 1;
    }
    function render(updateMap) {
      var size = desktop.matches ? 20 : 4;
      var pages = Math.max(1, Math.ceil(matches.length / size));
      page = Math.min(Math.max(page, 0), pages - 1);
      var visible = matches.slice(page * size, (page + 1) * size);
      if (!visible.some(function (record) { return record.id === section.__slMapSelectedId; })) {
        section.__slMapSelectedId = visible.length ? visible[0].id : '';
      }
      var fragment = document.createDocumentFragment();
      visible.forEach(function (record) { fragment.appendChild(makeCard(record)); });
      empty.hidden = matches.length > 0;
      fragment.appendChild(empty);
      rail.replaceChildren(fragment);
      rail.scrollTop = 0;
      if (status) status.textContent = matches.length + (matches.length === 1 ? ' local encontrado' : ' locais encontrados');
      pagination.hidden = pages <= 1;
      previous.disabled = page === 0;
      next.disabled = page === pages - 1;
      pageStatus.textContent = 'Página ' + (page + 1) + ' de ' + pages;
      if (!matches.length) {
        var panel = section.querySelector('[data-sl-map-panel]');
        panel.removeAttribute('aria-labelledby');
        clearMap(panel, 'Nenhum local encontrado. Altere os filtros para continuar.');
      } else if (updateMap || section.__slMapVisible) {
        mountInitial(section);
      }
      if (observer) {
        observed.forEach(function (card) { observer.unobserve(card); });
        observed = Array.prototype.slice.call(rail.querySelectorAll('[data-sl-location]')).slice(0, 4);
        observed.forEach(function (card) { observer.observe(card); });
      }
      updateHeight();
    }
    function apply(updateMap) {
      var term = search ? normalize(search.value) : '';
      matches = records.filter(function (record) {
        return (!state || !state.value || record.state === state.value)
          && (!city || !city.value || record.city === city.value)
          && (!term || record.search.includes(term));
      });
      render(updateMap);
    }
    function changeFilter() { page = 0; apply(true); }
    function movePage(offset) {
      page += offset;
      render(true);
      var tab = getTabs(section)[0];
      if (tab) activate(tab);
      if (!desktop.matches) rail.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    previous.addEventListener('click', function () { movePage(-1); });
    next.addEventListener('click', function () { movePage(1); });
    if (controls) {
      fill(state, records.map(function (record) { return record.state; }), 'Todos');
      cities();
      controls.hidden = false;
      search.addEventListener('input', changeFilter);
      state.addEventListener('change', function () { city.value = ''; cities(); changeFilter(); });
      city.addEventListener('change', changeFilter);
      controls.querySelector('[data-sl-clear]').addEventListener('click', function () {
        search.value = ''; state.value = ''; city.value = ''; cities(); changeFilter();
      });
    }
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(updateHeight);
      observer.observe(rail);
    }
    function resize() {
      var selected = matches.findIndex(function (record) { return record.id === section.__slMapSelectedId; });
      page = Math.floor(Math.max(0, selected) / (desktop.matches ? 20 : 4));
      render(section.__slMapVisible);
    }
    desktop.addEventListener('change', resize);
    if (document.fonts) document.fonts.ready.then(updateHeight);
    apply(false);

    var indexUrl = section.getAttribute('data-sl-index-url');
    var indexStatus = section.querySelector('[data-sl-index-status]');
    var indexMessage = section.querySelector('[data-sl-index-message]');
    var retry = section.querySelector('[data-sl-index-retry]');
    var loaded = false;
    function lock(value) {
      if (controls) controls.querySelectorAll('input, select, button').forEach(function (el) { el.disabled = value; });
      if (controls) controls.setAttribute('aria-busy', value ? 'true' : 'false');
    }
    async function loadIndex() {
      if (!indexUrl || loaded || loading || destroyed) return;
      loading = true;
      lock(true);
      indexStatus.hidden = false;
      retry.hidden = true;
      indexMessage.textContent = 'Carregando a lista completa de revendedores…';
      controller = new AbortController();
      try {
        var url = new URL(indexUrl, window.location.href);
        var visited = new Set();
        var rows = new Map();
        var total;
        do {
          if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid index pagination');
          visited.add(url.href);
          url.searchParams.set('section_id', 'sl-location-index');
          var response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Index request failed');
          var html = new DOMParser().parseFromString(await response.text(), 'text/html');
          var payload = html.querySelector('[data-sl-location-index]');
          if (!payload) throw new Error('Missing index');
          var data = JSON.parse(payload.textContent);
          if (!Array.isArray(data.items) || !Number.isInteger(data.total) || data.total < 0) throw new Error('Invalid index');
          total = data.total;
          data.items.forEach(function (row) {
            if (!row.handle || typeof row.name !== 'string') throw new Error('Invalid dealer');
            row.id = 'sl-tab-auto-' + section.id.replace(/^sl-section-/, '') + '-' + row.handle;
            rows.set(row.id, prepare(row));
          });
          if (data.next && !data.items.length) throw new Error('Empty index page');
          url = data.next ? new URL(data.next, url.href) : null;
        } while (url);
        if (rows.size !== total) throw new Error('Incomplete index');
        if (destroyed) return;
        records = Array.from(rows.values());
        loaded = true;
        if (controls) { fill(state, records.map(function (record) { return record.state; }), 'Todos'); cities(); }
        page = 0;
        apply(true);
        indexStatus.hidden = true;
        var serverPages = section.querySelector('[data-sl-server-pagination]');
        if (serverPages) serverPages.hidden = true;
        lock(false);
      } catch (error) {
        if (!destroyed) {
          indexMessage.textContent = 'Não foi possível carregar a lista completa. Tente novamente ou use as páginas abaixo.';
          retry.hidden = false;
        }
      } finally { loading = false; }
    }
    retry.addEventListener('click', loadIndex);
    section.__slMapLoadData = loadIndex;
    section.__slMapDispose = function () {
      destroyed = true;
      if (controller) controller.abort();
      if (observer) observer.disconnect();
      desktop.removeEventListener('change', resize);
    };
  }

  function bindKeyboard(section) {
    var tablist = section.querySelector('[data-sl-map-tablist]');
    if (!tablist) return;
    tablist.addEventListener('keydown', function (e) {
      var tabs = getTabs(section);
      if (!tabs.length) return;
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var next = -1;
      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = (i + 1) % tabs.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = (i - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
      }
      if (next >= 0) {
        e.preventDefault();
        activate(tabs[next]);
      }
    });
  }

  function initSection(section) {
    if (!section || section.__slMapInit) return;
    section.__slMapInit = true;

    var tabs = getTabs(section);
    if (!tabs.length) return;

    bindKeyboard(section);
    bindFilters(section);

    var hasIO = typeof window.IntersectionObserver === 'function';
    if (hasIO) {
      var io = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            section.__slMapVisible = true;
            mountInitial(section);
            if (section.__slMapLoadData) section.__slMapLoadData();
            io.disconnect();
            break;
          }
        }
      }, { rootMargin: '200px 0px', threshold: 0.05 });
      io.observe(section);
    } else {
      section.__slMapVisible = true;
      mountInitial(section);
      if (section.__slMapLoadData) section.__slMapLoadData();
    }
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-sl-map-section]');
    Array.prototype.forEach.call(sections, initSection);
  }

  // Public API used by inline onclick on each tab
  window.slMap = window.slMap || {};
  window.slMap.activate = activate;
  window.slMap.initSection = initSection;
  window.slMap.initAll = initAll;
  window.slMap.embedFromMapsUrl = embedFromMapsUrl;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor live updates
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-sl-map-section]').forEach(function (section) {
      if (section.__slMapDispose) section.__slMapDispose();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target && e.target.querySelector ? e.target.querySelector('[data-sl-tab]') : null;
    if (btn) activate(btn);
  });
})();
